'use client'

import Client from "./client";
import useGetCMS from "@/hooks/use-get-cms";
import { useLocale } from "next-intl";

export default function Comparation() {
  const locale = useLocale()

  const { data, loading } = useGetCMS({
    key: `unit-types-${locale}`,
    collection: "unit-types",
    config: {
      locale: locale,
    }
  });

  if(loading) {
    return <></>
  }

  const unitTypes = data?.data ?? [];
  
  const transformUnitType = unitTypes
    .map((unit) => {
      return unit.specification.map((spec) => ({
        text: `${unit.short_title} - Unit ${spec.short_label}`,
        ...spec,
        map: `${process.env.NEXT_PUBLIC_BASE_STATIC_URL}${spec.map.url}`,
        mini_map: `${process.env.NEXT_PUBLIC_BASE_STATIC_URL}${spec.mini_map.url}`,
        facility: spec.facility.map((facility) => ({
          ...facility,
          icon: `${process.env.NEXT_PUBLIC_BASE_STATIC_URL}${facility.icon.url}`,
        })),
      }));
    })
    .flat(4);

  return <Client types={transformUnitType} />;
}
